module.exports = __webpack_public_path__ + "img/free-tag.498b1ee0.png";